angular.module('vastdesk').
  component('thirdPartyFees',  {
    bindings: {
      formName: '@',
      formId: '@',
      nested: '<',
      thirdPartyFeeMetric: '@',
      thirdPartyFee: '<',
      thirdPartyFeeCurrency: '@',
      thirdPartyMetricMappings: '<',
      removeFeeFromRevenue: '<',
      currencyOptions: '<',
      currencyEditable: '<'
    },
    template: require("../templates/thirdPartyFees.html"),
    controllerAs: '$thirdPartyFeesCtrl',
    controller: function() {
      this.METRIC_REQUESTS = '0';
      this.METRIC_IMPRESSIONS = '1';
      this.METRIC_DIFF = '2';
      this.METRIC_REVSHARE = '3';
    }
});
